export function getFlexDirection(value) {
  return value === 'horizontal' ? 'row' : 'column'
}
